// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__dMCIi","spinner":"Timeline_spinner__aT-dG","svg":"Timeline_svg__RMcwB"};